// extracted by mini-css-extract-plugin
export default {"stepBody":"StepBody_stepBody__jL16J","stepProperties":"StepBody_stepProperties__7n5K4","stepBodyItem":"StepBody_stepBodyItem__Be1xS"};